async function scroller(id, setTargetIDToScrollTo = false, offset = -150) {
  if (setTargetIDToScrollTo) {
    setTargetIDToScrollTo(id);
  }

  const element = document.getElementById(id);

  if (element) {
    setTimeout(() => {
      // Get the element's position relative to the viewport
      const elementPosition = element.getBoundingClientRect().top;
      // Get the current scroll position
      const offsetPosition = elementPosition + window.pageYOffset + offset;

      // Scroll to the calculated position
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });

      setTimeout(() => {
        document.getElementById(id).focus();
      }, 2000);
    }, 100);
  }
}

export default scroller;
